var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup3087({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 5,
    transform: "matrix(-1 0 0 1 44 0)",
    fill: "#747BA9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4745 9C27.6546 9 29.4219 10.7673 29.4219 12.9474V18.2105C29.4219 20.3907 27.6546 22.1579 25.4745 22.1579C23.2944 22.1579 21.5271 20.3907 21.5271 18.2105V12.9474C21.5271 10.7673 23.2944 9 25.4745 9ZM23.5008 18.2105C23.5008 19.3005 24.3845 20.1842 25.4745 20.1842C26.5645 20.1842 27.4482 19.3005 27.4482 18.2105V12.9474C27.4482 11.8573 26.5645 10.9737 25.4745 10.9737C24.3845 10.9737 23.5008 11.8573 23.5008 12.9474V18.2105Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0526 20.1841C32.0526 21.2741 32.9363 22.1578 34.0263 22.1578C35.1164 22.1578 36 21.2741 36 20.1841C36 19.0941 35.1164 18.2104 34.0263 18.2104C32.9363 18.2104 32.0526 19.0941 32.0526 20.1841Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9735 12.9474V18.2105C12.9735 18.3474 12.9874 18.4811 13.014 18.6101C12.3707 18.8143 11.7606 19.0925 11.1933 19.4347C11.0677 19.0493 10.9998 18.6379 10.9998 18.2105V12.9474C10.9998 10.7673 12.767 9 14.9472 9C17.1273 9 18.8945 10.7673 18.8945 12.9474V18.2105C18.8945 18.4266 18.8772 18.6384 18.8437 18.845C18.234 18.5954 17.589 18.4141 16.9183 18.3108C16.9201 18.2775 16.9208 18.2441 16.9208 18.2105V12.9474C16.9208 11.8573 16.0372 10.9737 14.9472 10.9737C13.8572 10.9737 12.9735 11.8573 12.9735 12.9474Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36811 26.7632C8.36811 30.7601 11.6081 34.0001 15.605 34.0001C19.6018 34.0001 22.8418 30.7601 22.8418 26.7632C22.8418 22.7664 19.6018 19.5264 15.605 19.5264C11.6081 19.5264 8.36811 22.7664 8.36811 26.7632ZM11.6576 27.4211C11.2943 27.4211 10.9997 27.1265 10.9997 26.7632C10.9997 26.3999 11.2943 26.1053 11.6576 26.1053H17.964L15.7976 23.939C15.5407 23.682 15.5407 23.2654 15.7976 23.0085C16.0546 22.7516 16.4711 22.7516 16.7281 23.0085L20.0176 26.2979C20.2744 26.5549 20.2744 26.9715 20.0176 27.2285L16.7281 30.5179C16.4711 30.7748 16.0546 30.7748 15.7976 30.5179C15.5407 30.261 15.5407 29.8444 15.7976 29.5874L17.964 27.4211H11.6576Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3087);
export default __webpack_public_path__ + "static/media/Group 3087.c65474ba2dc15f5db22140e13405cb46.svg";
export { ForwardRef as ReactComponent };